// packages/domain/src/enums/UserRole.ts
export enum UserRole {
  User = 'User',
  Admin = 'Admin',
  Nutritionist = 'Nutritionist',
}
